import { t } from '../../../../common/components/T';
import { generateCompStylers, getStylePropsFunc } from '../../../../common/utils/styles';
import DropdownElement from '../../../../hybrid/library/DropdownElement';
import { svgSprite } from '../../../../hybrid/wrappers';
import ExcelButton from '../../../excelButton/ExcelButton';
import FormInput from '../../../form/components/form-input/FormInput/FormInput';

const SummaryHead = ({
    setShowModal,
    transl,
    compStyles,
    screenWidth,
    textsData,
    pageSettings,
    inputGlobFilter,
    globalSearch,
    selectPageConfig,
    exportData,
    dataFiltersToUrl
}) => {
    const getStyleProps = (...keys) => getStylePropsFunc(compStyles, ...keys);
    const { stylers, classes } = generateCompStylers(compStyles);

    return (
        <>
            <div {...getStyleProps('summaryBlock')}>
                {!screenWidth && (
                    <div {...getStyleProps('summaryBlockFilter')}>
                        <div {...getStyleProps('summaryBlockFilterFlexStart')}>
                            <p {...getStyleProps('summarySearthPlaceholder')}>
                                {textsData.globalSearthPlaceholderLabel || textsData.globalSearthPlaceholder}
                            </p>
                            <div {...getStyleProps('searthTable', 'customSearthTable')}>
                                {!pageSettings?.hideSearchInput ? (
                                    <>
                                        <FormInput
                                            value={inputGlobFilter?.[0]}
                                            compStyle={{
                                                icon: { fill: 'var(--greyExtraDarkColor)' },
                                                wrapper: {
                                                    ...stylers.searthTableInput,
                                                    className: classes.searthTableInput
                                                },
                                                global: {
                                                    icon: { width: '18px' }
                                                }
                                            }}
                                            handlers={{
                                                onChange: (val) => {
                                                    globalSearch(val);
                                                }
                                            }}
                                            search={{
                                                type: 'onInput',
                                                icon: 'search-thin'
                                            }}
                                            placeholder={
                                                textsData.globalSearthPlaceholder ||
                                                t('gridHeader-searchUser', 'Поиск пользователя', 'widget', transl, 'gridFilter')
                                            }
                                            buttons={
                                                !pageSettings?.hideGlobalSearch
                                                    ? {
                                                          global: {
                                                              icon: 'sliders',
                                                              handler: () => setShowModal(true)
                                                          }
                                                      }
                                                    : {}
                                            }
                                        />
                                    </>
                                ) : (
                                    <div
                                        {...getStyleProps('searthFilterOpen', 'searthFilterOpenStatic', 'formCursorPointer')}
                                        onClick={() => setShowModal(true)}
                                    >
                                        {svgSprite('search-thin', getStyleProps('userSearthSvgFillGrey'))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {pageSettings?.summary || null}
            </div>
            <div {...getStyleProps('summaryBlockFilter', 'summaryBlockFilterSelectPage')}>
                <div {...getStyleProps('summaryBlockFilterFlex')}>
                    <div {...getStyleProps('selectPageWrap')}>
                        <p {...getStyleProps('selectPageText')}>
                            {(textsData.itemOnPage ||
                                (screenWidth
                                    ? t('gridHeader-selectPageTextXs', 'Записей', 'widget', transl, 'gridFilter')
                                    : t('gridHeader-sselectPageText', 'Записей на странице', 'widget', transl, 'gridFilter'))) +
                                ':'}
                        </p>
                        <DropdownElement componentConfig={selectPageConfig} />
                    </div>
                    {exportData && <ExcelButton filter={dataFiltersToUrl} exportData={exportData} />}
                </div>
            </div>
        </>
    );
};
export default SummaryHead;
